import React, { ReactElement } from 'react';
import { useRouter } from 'next/router';

import { addResultPageFiltersToUrl } from '@/lib/utils/queryParamFilterConversions';
import { Filters } from '@/interfaces';
import missingHotelImage from '@/static/icons/noHotel.jpg';

interface Props {
    filters: Filters;
}

export const NoHotelWarning: React.FC<Props> = ({ filters }): ReactElement => {
    const router = useRouter();
    const resultPath = `${router.basePath}/resultat`;

    return (
        <div className="u-text-center u-mt32" data-testid="noHotelWarning">
            <h1>404</h1>
            <p>
                Hotellet du prøver å finne ser ikke ut til å finnes. Gå{' '}
                <a href={addResultPageFiltersToUrl(resultPath, filters)}>tilbake til pakkereiser</a> for å se andre alternativer.
            </p>
            <div className="u-mt64 u-mb32 u-mh16">
                <img src={missingHotelImage.src} className="img-format__img u-r-size2of3" alt="Katt som sitter på en ball" />
            </div>
        </div>
    );
};
